import type { CSSProperties, HTMLAttributes } from "react";
import { injectCss } from "./injectCss";

const CSS = `
.js-avatar{
  display:inline-flex;align-items:center;justify-content:center;
  border-radius:50%;font-family:var(--font-sans);font-weight:var(--weight-bold);
  color:#fff;overflow:hidden;flex:none;user-select:none;line-height:1;
}
.js-avatar img{width:100%;height:100%;object-fit:cover}
.js-avatar--xs{width:24px;height:24px;font-size:10px}
.js-avatar--sm{width:32px;height:32px;font-size:12px}
.js-avatar--md{width:40px;height:40px;font-size:15px}
.js-avatar--lg{width:56px;height:56px;font-size:20px}
.js-avatar--ring{box-shadow:0 0 0 2px var(--surface-card),0 0 0 4px var(--brand)}
`;

const TINTS = ["#0d8d75", "#e57519", "#2f74e0", "#1f9d57", "#9a5bd1", "#d8447a"];

function pickTint(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return TINTS[h % TINTS.length];
}

function initials(name = "") {
  const n = name.trim();
  if (!n) return "?";
  if (/[一-鿿]/.test(n)) return n.slice(-2);
  const parts = n.split(/\s+/);
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  name?: string;
  src?: string;
  size?: "xs" | "sm" | "md" | "lg";
  ring?: boolean;
  style?: CSSProperties;
}

export function Avatar({ name = "", src = "", size = "md", ring = false, className = "", style, ...rest }: AvatarProps) {
  injectCss("js-avatar-css", CSS);
  const cls = ["js-avatar", `js-avatar--${size}`, ring ? "js-avatar--ring" : "", className].filter(Boolean).join(" ");
  const bg = src ? undefined : pickTint(name);
  return (
    <span className={cls} style={{ background: bg, ...style }} {...rest}>
      {src ? <img src={src} alt={name} /> : initials(name)}
    </span>
  );
}
